'use strict'

import { Route } from 'react-router-dom'

import React from 'react'

let TidewaysRoute = function(router, route, Component, additionalProps = {}) {
    return <Route exact path={router.reactRoute(route)} render={props => <Component {...props} {...additionalProps} />} />
}

export default TidewaysRoute
